/** Minute in seconds. */
export const MINUTE = 60
/** Hour in seconds. */
export const HOUR = MINUTE * 60
/** Day in seconds. */
export const DAY = HOUR * 24
/** Year in seconds. */
export const YEAR = DAY * 365

export const phoneNumberRegex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/i

export const mobileNumberRegex = /^(?:\+44|44|0)7\d{9}$/

export const nameRegex = /^(?!.*['\u2019]{2})(?:[\p{L}\p{M}]+\.?)+(?:[ \-'\u2019](?:[\p{L}\p{M}]+\.?)+)*['\u2019]?$/u
